import { ChevronUpIcon, ChevronDownIcon } from '@rsos/assets/icons';
import { IconWrapper } from '../styles/SortIconWrapper.styles';

/**
 * @param {Boolean} isReversed - determine direction of chevron icon
 */

export const SortIconWrapper = ({ isReversed }) => {
  return (
    <IconWrapper>
      {isReversed ? (
        <ChevronDownIcon width={12} height={12} />
      ) : (
        <ChevronUpIcon width={12} height={12} />
      )}
    </IconWrapper>
  );
};
